const HospitalStructure = () => import('./hospital-structure.vue');
const Operations = () => import('./hospital-structure/operations/operations.vue');
const HospitalStructureSetup = () => import('./hospital-structure/operations/hospital-structure-setup/hospital-structure-setup.vue');
const Setups = () => import('./hospital-structure/setups/setups.vue');
const ClassesSetup = () => import('./hospital-structure/setups/accommodation-classes/accommodation-classes.vue');
const NewRoom = () => import('./hospital-structure/operations/new-room/new-room.vue');
const Groups = () => import('./hospital-structure/setups/groups/groups.vue');

import localeEn from '../../locales/en'
import localeAr from '../../locales/ar'
export const translation = {
    en: {
        ...localeEn
    },
    ar: {
        ...localeAr
    }
}

const lang = localStorage.getItem('NG_TRANSLATE_LANG_KEY');

const HospitalStructureRoutes = [
    {
        path: '/hospital-structure',
        component: HospitalStructure,
        name: '/hospital-structure',
        meta: {
            title: translation[lang].Nav.HospitalStructure.HospitalStructure,
            bodyClass: 'HospitalStructure-module',
        },
        children: [
            {
                path: 'operations',
                name: '/hospital-structure/operations/operations',
                meta: {
                    title: translation[lang].Nav.HospitalStructure.Operations
                },
                component: Operations,
                children: [
                    {
                        path: 'hospital-structure-setup',
                        name: 'hospital-structure-setup',
                        meta: {
                            title: translation[lang].Nav.HospitalStructure.HospitalStructureSetup,
                            clickable: true
                        },
                        component: Operations,
                        children: [
                            {
                                path: '',
                                name: '/hospital-structure/operations/hospital-structure-setup/hospital-structure-setup',
                                meta: {
                                    title: translation[lang].Nav.HospitalStructure.HospitalStructureSetup,
                                    hide: true
                                },
                                component: HospitalStructureSetup,
                            },
                            {
                                path: 'new-room',
                                name: '/hospital-structure/operations/new-room/new-room',
                                meta: {
                                    title: translation[lang].Nav.HospitalStructure.NewRoom
                                },
                                component: NewRoom,
                            },
                            {
                                path: 'edit-room',
                                name: '/hospital-structure/operations/new-room/edit-room',
                                meta: {
                                    title: translation[lang].Nav.HospitalStructure.EditRoom
                                },
                                component: NewRoom,
                            },
                            {
                                path: 'view-room',
                                name: '/hospital-structure/operations/new-room/view-room',
                                meta: {
                                    title: translation[lang].Nav.HospitalStructure.ViewRoom
                                },
                                component: NewRoom,
                            },
                        ],
                    }
                ],
            },
            {
                path: 'setups',
                name: '/hospital-structure/setups/setups',
                meta: {
                    title: translation[lang].Nav.HospitalStructure.Setup
                },
                component: Setups,
                children: [
                    {
                        path: 'accommodation-classes',
                        name: '/hospital-structure/setups/accommodation-classes/accommodation-classes',
                        meta: {
                            title: translation[lang].Nav.HospitalStructure.ClassesSetup
                        },
                        component: ClassesSetup,
                    },

                    {
                        path: 'groups',
                        name: '/hospital-structure/setups/groups/groups',
                        meta: {
                            title: translation[lang].Nav.HospitalStructure.Groups
                        },
                        component: Groups,
                    }
                ]
            }
        ]
    }
];

export default HospitalStructureRoutes;